(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};

  class VideoCountButton {
    /**
     * Initializes a new instance of the class.
     * Sets the rootNode property to null.
     */
    constructor() {
      this.rootNode = null;
    }

    /**
     * Sets the root node for the instance.
     *
     * @param {HTMLElement} rootNode - The root DOM node to be assigned.
     * @returns {this} Returns the current instance for chaining.
     */
    setRootNode(rootNode) {
      this.rootNode = rootNode;
      return this;
    }

    /**
     * Initializes the video count button by binding necessary events.
     * @returns {this} Returns the current instance for chaining.
     */
    initialize() {
      this.bindEvents();
      return this;
    }

    /**
     * Binds the click event listener to the node associated with this instance.
     * The click event will trigger the `onClick` handler, which is bound to the current context.
     */
    bindEvents() {
      const node = this.getNode();
      if (!node) {
        return;
      }
      this.onClick = this.onClick.bind(this);
      node.addEventListener('click', this.onClick);
    }

    /**
     * Returns the DOM node for the video count button component.
     *
     * @returns {Element} The video count button element, or null if not found.
     */
    getNode() {
      return this.rootNode.querySelector('[data-component="video-count-button"]');
    }

    /**
     * Retrieves the video image element within the root node.
     * @returns {Element} The element with the 'data-video-image' attribute, or null if not found.
     */
    getVideoImage() {
      return this.rootNode.querySelector('[data-video-image]');
    }

    /**
     * Handles the click event for the video count button.
     * Dispatches a custom 'galleryOnPageClick' event with the media ID as detail if a media element is found.
     *
     */
    onClick() {
      const mediaElement = this.getVideoImage();
      if (!mediaElement) {
        return;
      }
      document.body.dispatchEvent(new CustomEvent('galleryOnPageClick', {
        detail: {
          id: mediaElement.dataset.mediaId,
          originator: 'videoCountButton',
        }
      }));
    }

    /**
     * Removes the click event listener from the associated DOM node.
     * Should be called to clean up resources when the instance is no longer needed.
     */
    destroy() {
      const node = this.getNode();
      if (!node) {
        return;
      }
      node.removeEventListener('click', this.onClick);
    }
  }

  global.NewHomeSource.GalleryOnPage.VideoCountButton = VideoCountButton;
}(window));
